import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Identification() {
  const scenarios = [{
    emoji: '😰',
    text: 'Tu hijo se lanza al piso del supermercado mientras todos miran y tú no sabes si gritar, ignorarlo o salir corriendo.'
  }, {
    emoji: '😤',
    text: 'Un simple "no" dispara 40 minutos de llanto, gritos y caos total que destruye la tarde entera.'
  }, {
    emoji: '🌙',
    text: 'La hora de dormir se convierte en una guerra que nadie gana y deja a todos agotados.'
  }, {
    emoji: '😣',
    text: 'Subes el tono. Él sube más. Terminas gritando más fuerte de lo que querías.'
  }, {
    emoji: '💔',
    text: 'A las 11 PM te preguntas: "¿Por qué no puedo manejar esto mejor?"'
  }];
  return <section className="py-20 bg-brand-cream px-6" data-id="element-191">
      <div className="max-w-3xl mx-auto" data-id="element-192">
        <FadeIn data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" data-id="element-194">
            ¿Alguna de estas escenas te suena familiar?
          </h2>
          <p className="text-center text-gray-600 mb-12 italic" data-id="element-195">
            Marca mentalmente cada una que hayas vivido
          </p>
        </FadeIn>

        <div className="space-y-4 mb-12" data-id="element-196">
          {scenarios.map((scenario, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-197">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-198">
                <div className="flex items-start gap-4" data-id="element-199">
                  <span className="text-3xl flex-shrink-0" data-id="element-200">
                    {scenario.emoji}
                  </span>
                  <p className="text-lg text-gray-700 leading-relaxed pt-1" data-id="element-201">
                    {scenario.text}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-202">
          <div className="bg-brand-sage-light border-2 border-brand-sage rounded-2xl p-8 text-center" data-id="element-203">
            <p className="text-xl font-bold text-brand-charcoal" data-id="element-204">
              Si marcaste aunque sea UNO de estos puntos,
              <br data-id="element-205" />
              este protocolo fue escrito exactamente para ti.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}